export default {
	state: {
		shops: [
			{
				id: '001',
				street: 'пр-кт Александровск-Грушевский, д. 13',
				point: 'ЛЕНТА'
			},
			{
				id: '002',
				street: 'пр-кт Революции, дом 113',
				point: 'МАГНИТ'
			},
			{
				id: '003',
				street: 'пр-кт Ленинского Комсомола, дом 65',
				point: 'МАГНИТ'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getSahti (state) {
			return state.shops
		}
	}
}